/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "769b9b008feb1d94a62b13024e37dfdc431b1462";
